module.exports = __webpack_public_path__ + "static/media/FondoAlumnos.5cc7ce78.png";